import React from "react";
import {
	Box,
	Grid,
	Typography,
	Paper,
	Avatar,
	Button,
	LinearProgress,
	Card,
	CardContent,
} from "@mui/material";
import {
	AttachMoney,
	AccountBalanceWallet,
	Assessment,
	Settings,
	SyncAlt,
} from "@mui/icons-material";
import { SiBinance } from "react-icons/si";
import { TbBrandCoinbase } from "react-icons/tb";

const UDIntegrationUI = () => {
	// Example stats data
	const stats = [
		{
			title: "Total Invested",
			value: "$2B+",
			icon: <AttachMoney fontSize="large" color="primary" />,
			progress: 75,
		},
		{
			title: "Active Investments",
			value: "500,000+",
			icon: <AccountBalanceWallet fontSize="large" color="secondary" />,
			progress: 50,
		},
		{
			title: "Integrated Platform",
			value: "10+",
			icon: <SyncAlt fontSize="large" color="info" />,
			progress: 80,
		},
		{
			title: "Performance",
			value: "95%",
			icon: <Assessment fontSize="large" color="success" />,
			progress: 95,
		},
	];

	// Static integrations data
	const integrations = [
		{ name: "Coinbase", status: "Connected", icon: <TbBrandCoinbase /> },
		{ name: "Binance", status: "Connected", icon: <SiBinance /> },
		{ name: "Kraken", status: "Connected", icon: <AccountBalanceWallet /> },
	];

	return (
		<Box sx={{ p: 4, backgroundColor: "#f4f6f8" }}>
			{/* Header */}
			<Typography
				variant="h3"
				gutterBottom
				sx={{ fontWeight: 700, color: "#1f2937" }}>
				Investment Integration
			</Typography>
			<Typography
				variant="subtitle1"
				gutterBottom
				sx={{ mb: 4, color: "#6b7280" }}>
				Connected platforms
			</Typography>

			{/* Metrics Overview */}
			<Grid container spacing={3} sx={{ mb: 5 }}>
				{stats.map((stat, index) => (
					<Grid item xs={12} sm={6} md={3} key={index}>
						<Paper
							elevation={3}
							sx={{
								p: 3,
								borderRadius: 2,
								display: "flex",
								flexDirection: "column",
								alignItems: "center",
								width: "10rem",
								height: "15rem",
								transition: "transform 0.2s",
								"&:hover": { transform: "translateY(-4px)" },
							}}>
							<Avatar sx={{ mb: 2, bgcolor: "background.paper" }}>
								{stat.icon}
							</Avatar>
							<Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
								{stat.title}
							</Typography>
							<Typography
								variant="h4"
								sx={{ mb: 2, fontWeight: 700, color: "#3b82f6" }}>
								{stat.value}
							</Typography>
							<LinearProgress
								variant="determinate"
								value={stat.progress}
								sx={{
									width: "100%",
									borderRadius: 1,
									transition: "width 0.3s",
								}}
							/>
						</Paper>
					</Grid>
				))}
			</Grid>

			{/* Connect New Integration */}
			<Box
				sx={{
					mb: 4,
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
				}}>
				<Typography variant="h5" sx={{ fontWeight: 600, color: "#111827" }}>
					Connected Platforms
				</Typography>
				{/* <Button
					variant="contained"
					startIcon={<SyncAlt />}
					sx={{ textTransform: "none" }}>
					Connect New Platform
				</Button> */}
			</Box>

			{/* Integrations List */}
			<Grid container spacing={2}>
				{integrations.map((intg, index) => (
					<Grid item xs={12} md={4} key={index}>
						<Card
							sx={{
								borderRadius: 2,
								boxShadow: 2,
								transition: "box-shadow 0.3s, transform 0.3s",
								"&:hover": {
									boxShadow: 6,
									cursor: "pointer",
									transform: "translateY(-2px)",
								},
							}}>
							<CardContent
								sx={{
									display: "flex",
									alignItems: "center",
									justifyContent: "space-between",
								}}>
								<Box sx={{ display: "flex", alignItems: "center" }}>
									<Avatar sx={{ bgcolor: "primary.main", mr: 2 }}>
										{intg.icon}
									</Avatar>
									<Box>
										<Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
											{intg.name}
										</Typography>
										<Typography
											variant="body2"
											sx={{
												color: intg.status === "Connected" ? "green" : "orange",
											}}>
											{intg.status}
										</Typography>
									</Box>
								</Box>
								{/* <Button
									variant="outlined"
									size="small"
									startIcon={<Settings />}>
									Manage
								</Button> */}
							</CardContent>
						</Card>
					</Grid>
				))}
			</Grid>

			{/* Portfolio Performance */}
		</Box>
	);
};

export default UDIntegrationUI;
